document.addEventListener("DOMContentLoaded", () => {
    /** init gtm after 3500 seconds - this could be adjusted */
    if(screen.width < 500) {
      setTimeout(initGTM, 6500);
    } else {
      setTimeout(initGTM, 3500);
    }
});

function loadPreviewBar() {
  const previewBarInjector2 = new Shopify.PreviewBarInjector({
    targetNode: document.body,
    iframeRoot: 'https://zenwise.com',
    iframeSrc: 'https://zenwise.com/preview_bar',
    themeStoreId: '411',
    permanentDomain: 'zenwise-pixelsupply.myshopify.com',
  });
  previewBarInjector2.init();
}

document.addEventListener("scroll", initGTMOnEvent);
document.addEventListener("mousemove", initGTMOnEvent);
document.addEventListener("touchstart", initGTMOnEvent);
function initGTMOnEvent(event) {
  initGTM();
  event.currentTarget.removeEventListener(event.type, initGTMOnEvent); // remove the event listener that got triggered
}

function addScript( url, onLoad = null) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  if( onLoad ) {
    script.onload = onLoad; 
  }
  script.src = url;
  document.head.appendChild(script);
}

function initGTM() {
  if (window.gtmDidInit) {
    return false;
  }
  window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.

  onLoadGtm = () => {
    dataLayer.push({
      event: "gtm.js",
      "gtm.start": new Date().getTime(),
      "gtm.uniqueEventId": 0,
    });
  };

  addScript( "https://www.googletagmanager.com/gtm.js?id=GTM-NNMQDGS",onLoadGtm);
  addScript("https://ws.audioeye.com/ae.js");  
  addScript("https://www.googleoptimize.com/optimize.js?id=OPT-M6TLXK5");
  //addScript("https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=16840"); 
  
  if ( window.loadScripts ) { 
    window.loadScripts.forEach(element => {
      if(element.includes('preview_bar_injector')) {
        addScript(element, loadPreviewBar);
      } else {
        addScript(element );
      }
    });
  }

}
